import $ from "jquery";
import "jquery-validation/dist/jquery.validate";
import i18n from "@I18n/services/i18n";
import messages from "./messages";

$(document).ready(function () {
  // Forms - Custom validation rules: Email
  $.validator.addMethod(
    "customEmail",
    function (value, element) {
      return (
        this.optional(element) ||
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(
          value.trim()
        )
      );
    },
    i18n.formatMessage(messages.email)
  );

  // Forms - Custom validation rules: Email
  $.validator.addMethod(
    "captchaContact",
    function (value, element) {
      return i18n.locale === "fr-FR" ? value == "lundi" : value === "maandag";
    },
    i18n.formatMessage(messages.contactUsCaptcha)
  );

  // Forms - Detect if there is an @ in a field
  $.validator.addMethod(
    "detectAtInInput",
    function (value, element) {
      var valid = false;
      var check = /[\u0040]/.test(value);
      if (check == false) valid = true;
      return this.optional(element) || valid;
    },
    "There is an error somewhere"
  );
});
